import Vue from "vue";
import VueRouter from "vue-router";
// 滚动加载条
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import mainContent from "components/common/mainContent"; //基础组件
NProgress.configure({
	showSpinner: false,
}); // 隐藏进度环

const indexVue = () => import("@/components/index.vue");

//解决首屏加载慢，通过路由懒加载import按需导入相应的组件(将组件映射到路由)
const loginComponent = () => import("@/views/account/newLogin"); //登录
const registerComponent = () => import("@/views/account/register"); //registerComponent
const resetPasswordComponent = () => import("@/views/account/resetPassword"); //registerComponent
const noPageComponent = () => import("@/components/common/Error"); //404
const homePage = () => import("@/views/homePage/index"); //首页
const upgradeUserComponent = () => import("@/views/upgradeUser");
// 系统管理
const userComponent = () => import("@/views/system/user"); //用户管理
const appUserComponent = () => import("@/views/system/appUser"); //app用户管理
const roleComponent = () => import("@/views/system/role"); //角色管理
const authComponent = () => import("@/views/system/auth"); //权限管理
const menuComponent = () => import("@/views/system/menu"); //菜单管理
const logComponent = () => import("@/views/system/log"); //日志管理
const frontEndLogComponent = () => import("@/views/system/frontEndLog"); //前端日志
// 内容管理
const articeComponent = () => import("@/views/content/artice/index"); //文章管理
const articeEditComponent = () => import("@/views/content/artice/edit"); //文章修改
const tagComponent = () => import("@/views/content/tag/index"); //标签管理
const tagClassComponent = () => import("@/views/content/tag/tagClass"); //标签分类管理
const articleCategory = () => import("@/views/content/articleCategory"); //文章分类
const articleCategoryHide = () => import("@/views/content/articleCategoryHide"); //文章隐藏分类
const articleCategoryHideAuth = () =>
	import("@/views/content/articleCategoryHideAuth"); //文章隐藏分类授权
const dailyUpdate = () => import("@/views/content/daily/dailyUpdate"); //每日更新
const dailyUpdateDetails = () => import("@/views/content/daily/details"); //详情
const enterpriseChannel = () => import("@/views/content/enterpriseChannel"); //企业频道
const channel = () => import("@/views/content/channel/index.vue"); //频道列表
const keyword = () => import("@/views/content/keyword"); //关键字列表
const resource = () => import("@/views/content/resources"); //关键字列表
const invite = () => import("@/views/content/invite"); //邀请码
// 自动化推送
const pushMessageComponent = () => import("@/views/automatePush/push_message"); // 自定义推送消息
const pushArticleComponent = () => import("@/views/automatePush/push_article"); // 自定义推送消息
const pushVersionComponent = () => import("@/views/automatePush/version"); //版本更新
const pushTagComponent = () => import("@/views/automatePush/push_tag"); //订阅标签
const pushLogComponent = () => import("@/views/automatePush/pushLog"); //推送日志
// 工单管理
const depositRec = () => import("@/views/workManage/depositRec"); //充值记录
const consumingRec = () => import("@/views/workManage/consumingRec"); //消费记录
const workOrderComponent = () => import("@/views/workManage/workOrder"); //工单信息管理
//其它
const aboutComponent = () => import("@/views/other/about"); //关于我们
const feedBackComponent = () => import("@/views/other/feedBack"); //意见反馈管理
const customizationComponent = () => import("@/views/other/customization"); //定制管理
const collectionComponent = () => import("@/views/other/collection"); //收藏管理
const emailComponent = () => import("@/views/other/email/index"); //邮箱管理
const versionManage = () => import("@/views/other/versionManage"); //版本管理
const dictionaryManage = () => import("@/views/other/dictionaryManage"); //字典管理
const sortCountComponent = () => import("@/views/other/sortCount"); //字典管理

// 运维管理
const mochaItomMessagePush = () => import("@/views/mochaItom/messagePush"); //字典管理
const articleSort = () => import("@/views/mochaItom/articleSort"); //文章分类
const articleList = () => import("@/views/mochaItom/articleList"); //文章列表
const articleEdit = () => import("@/views/mochaItom/articleEdit"); //文章录入

Vue.use(VueRouter);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题(解决路由在 push/replace 了相同地址报错的问题)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch((err) => err);
};

const routes = [
	{
		path: "/", //网页中具体路径的显示
		name: "", //给path设置的别名   给路由命名
		component: loginComponent, //路由路径下页面渲染的内容
		hidden: true,
		meta: {
			requireAuth: false,
		},
	},
	{
		path: "/404",
		name: "noPage",
		component: noPageComponent,
		hidden: true,
		meta: {
			requireAuth: false,
		},
	},
	{
		path: "/login",
		name: "登录",
		component: loginComponent,
		hidden: true,
		meta: {
			requireAuth: false,
		},
	},
	{
		path: "/register",
		name: "注册",
		component: registerComponent,
		hidden: true,
		meta: {
			requireAuth: false,
		},
	},
	{
		path: "/resetPassword",
		name: "忘记密码",
		component: resetPasswordComponent,
		hidden: true,
		meta: {
			requireAuth: false,
		},
	},
	{
		path: "/new",
		name: "new",
		component: indexVue,
		hidden: true,
		redirect: "/new/uamp/callback.action",
		meta: {
			requireAuth: false,
		},
		children: [
			{
				path: "uamp",
				component: indexVue,
				children: [
					{
						path: "callback.action",
						name: "绑定手机号",
						component: upgradeUserComponent,
						meta: {
							title: "首页",
						},
					},
				],
			},
		],
	},
	{
		path: "/home", //登录成功之后跳转到这
		name: "homePage",
		component: mainContent, //继承主页面样式
		redirect: "/homePage", //然后重定向到homePage
		children: [
			{
				path: "/homePage",
				name: "首页",
				component: homePage,
				meta: {
					title: "首页",
					// keepAlive: true
				},
			},
		],
	},

	{
		path: "/system",
		name: "系统管理",
		component: mainContent,
		meta: {
			title: "系统管理",
		},
		children: [
			{
				path: "/user",
				name: "用户管理",
				component: userComponent,
				meta: {
					title: "用户管理",
				},
				// 路由内独享守卫
				beforeEnter: (to, from, next) => {
					console.log("beforeEnter 路由独享守卫");
					next();
				},
			},
			{
				path: "/appUser",
				name: "app用户管理",
				component: appUserComponent,
				meta: {
					title: "app用户管理",
				},
			},
			{
				path: "/role",
				name: "角色管理",
				component: roleComponent,
				meta: {
					title: "角色管理",
				},
			},
			{
				path: "/auth",
				name: "权限管理",
				component: authComponent,
				meta: {
					title: "权限管理",
				},
			},
			{
				path: "/menu",
				name: "菜单管理",
				component: menuComponent,
				meta: {
					title: "菜单管理",
				},
			},
			{
				path: "/log",
				name: "日志管理",
				component: logComponent,
				meta: {
					title: "日志管理",
				},
			},
			{
				path: "/frontEndLog",
				name: "app日志",
				component: frontEndLogComponent,
				meta: {
					title: "app日志",
				},
			},
		],
	},
	{
		path: "/workManage",
		name: "workManage",
		component: mainContent,
		meta: {
			title: "工单管理",
		},
		children: [
			{
				path: "/depositRecords",
				name: "充值记录",
				component: depositRec,
				meta: {
					title: "充值记录",
				},
			},
			{
				path: "/consumingRec",
				name: "消费记录",
				component: consumingRec,
				meta: {
					title: "消费记录",
				},
			},
			{
				path: "/workOrder",
				name: "工单管理",
				component: workOrderComponent,
				meta: {
					title: "工单管理",
				},
			},
		],
	},
	{
		path: "/context",
		name: "内容管理",
		component: mainContent,
		meta: {
			title: "内容管理",
		},
		children: [
			{
				path: "/artice",
				name: "文章管理",
				component: articeComponent,
				meta: {
					title: "文章管理",
				},
			},
			{
				path: "/edit",
				name: "文章编辑",
				component: articeEditComponent,
				meta: {
					title: "文章编辑",
				},
			},
			{
				path: "/tag",
				name: "标签管理",
				component: tagComponent,
				meta: {
					title: "标签管理",
				},
			},
			{
				path: "/tagClass",
				name: "标签分类",
				component: tagClassComponent,
				meta: {
					title: "标签分类",
				},
			},
			{
				path: "/enterpriseChannel",
				name: "企业频道",
				component: enterpriseChannel,
				meta: {
					title: "企业频道",
				},
			},
			{
				path: "/articleCategory",
				name: "文章分类",
				component: articleCategory,
				meta: {
					title: "文章分类",
				},
			},
			{
				path: "/hiddenClass",
				name: "隐藏分类",
				component: articleCategoryHide,
				meta: {
					title: "隐藏分类",
				},
			},
			{
				path: "/articleCategoryHideAuth",
				name: "",
				component: articleCategoryHideAuth,
				meta: {
					title: "文章分类",
				},
			},
			{
				path: "/dailyUpdate",
				name: "每日更新",
				component: dailyUpdate,
				meta: {
					title: "每日更新",
					keepAlive: true,
				},
			},
			{
				path: "/dailyDetails",
				name: "dailyDetails",
				component: dailyUpdateDetails,
				meta: {
					title: "每日更新",
				},
			},
			{
				path: "/channel",
				name: "频道列表",
				component: channel,
				meta: {
					title: "频道列表",
				},
			},
			{
				path: "/keyword",
				name: "关键字列表",
				component: keyword,
				meta: {
					title: "关键字列表",
				},
			},
			{
				path: "/resource",
				name: "资源列表",
				component: resource,
				meta: {
					title: "资源列表",
				},
			},
			{
				path: "/invite",
				name: "邀请码",
				component: invite,
				meta: {
					title: "邀请码",
					icon: "icon-wenzhangfenlei1",
				},
			},
		],
	},
	{
		path: "/other",
		name: "其他",
		component: mainContent,
		meta: {
			title: "其他",
		},
		children: [
			{
				path: "/about",
				name: "关于我们",
				component: aboutComponent,
				meta: {
					title: "关于我们",
				},
			},
			{
				path: "/feedBack",
				name: "意见反馈管理",
				component: feedBackComponent,
				meta: {
					title: "意见反馈管理",
				},
			},
			{
				path: "/customization",
				name: "定制管理",
				component: customizationComponent,
				meta: {
					title: "定制管理",
				},
			},
			{
				path: "/collection",
				name: "收藏管理",
				component: collectionComponent,
				meta: {
					title: "收藏管理",
				},
			},
			{
				path: "/email",
				name: "邮箱管理",
				component: emailComponent,
				meta: {
					title: "邮箱管理",
				},
			},
			{
				path: "/dictionaryManage",
				name: "字典管理",
				component: dictionaryManage,
				meta: {
					title: "字典管理",
				},
			},
			{
				path: "/versionManage",
				name: "版本管理",
				component: versionManage,
				meta: {
					title: "版本管理",
				},
			},
		],
	},
	{
		path: "/automatedPush",
		name: "自动化推送",
		component: mainContent,
		meta: {
			title: "自动化推送",
		},
		children: [
			{
				path: "/message",
				name: "自定义消息",
				component: pushMessageComponent,
				meta: {
					title: "自定义消息",
				},
			},
			{
				path: "/pushLog",
				name: "推送日志",
				component: pushLogComponent,
				meta: {
					title: "推送日志",
				},
			},
			{
				path: "/article",
				name: "文章推送",
				component: pushArticleComponent,
				meta: {
					title: "文章推送",
				},
			},
			{
				path: "/tage",
				name: "订阅标签",
				component: pushTagComponent,
				meta: {
					title: "订阅标签",
				},
			},
			{
				path: "/version",
				name: "版本更新",
				component: pushVersionComponent,
				meta: {
					title: "版本更新",
				},
			},
			{
				path: "/navigation",
				name: "分类统计",
				component: sortCountComponent,
				meta: {
					title: "分类统计",
				},
			},
		],
	},
	{
		path: "/operation",
		name: "运维管理",
		component: mainContent,
		meta: {
			title: "运维管理",
		},
		children: [
			{
				path: "/official",
				name: "公众号推送",
				component: mochaItomMessagePush,
				meta: {
					title: "公众号推送",
				},
			},
			{
				path: "/articleSort",
				name: "文章分类",
				component: articleSort,
				meta: {
					title: "文章分类",
					icon: "icon-wenzhangfenlei",
				},
			},
			{
				path: "/articleEdit",
				name: "文章录入",
				component: articleEdit,
				meta: {
					title: "文章录入",
					icon: "icon-wenzhangfenlei",
				},
			},
			{
				path: "/articleList",
				name: "文章列表",
				component: articleList,
				meta: {
					title: "文章列表",
					icon: "icon-wenzhangfenlei1",
				},
			},
		],
	},
	{
		path: "*",
		redirect: "/404",
	}, //所有匹配不到得路径转到这里
];

const router = new VueRouter({
	mode: "history",
	base: "/view",
	routes,
	scrollBehavior(to, from, savedPosition) {
		//设置页面滚动行为，VueRouter原生钩子函数
		/*
		 * 如果有 savedPosition 说明是第二次进入并已经触发过滚动，所以会滚动到之前打开的位置，如果是第一次进入没有savedPosition则滚动到最顶层
		 */
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0,
			};
		}
	},
});

// 免权限白名单
const whiteList = [
	"/login",
	"/register",
	"/resetPassword",
	"/uamp/callback.action",
	"/new/uamp/callback.action",
]; // 免权限白名单

//全局前置导航守卫
//路由开始之前的操作  to：即将进入的路由对象 from：当前导航正要离开的路由对象
//                   next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数
router.beforeEach((to, from, next) => {
	let token = localStorage.getItem("token");
	if (to.name) {
		document.title = to.name;
	}
	NProgress.start();
	if (token) {
		// 已经登录并且要跳转的页面是登录页或者空页，直接重定向到首页
		if (to.path === "/") {
			next({
				path: "/home",
			});
			NProgress.done();
		} else {
			next();
		}
	} else {
		/* has no token*/
		if (whiteList.includes(to.path)) {
			// 在免登录白名单，直接进入
			next();
		} else {
			next({
				path: "/login",
			}); // 否则全部重定向到登录页
			NProgress.done();
		}
	}
});

//全局后置导航守卫
router.afterEach((route) => {
	NProgress.done();
});

export default router;
